var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar-container"},[_c('h1',{staticClass:"nav-bar-title"},[_vm._v("Help Center")]),_vm._v(" "),_c('div',{staticClass:"nav-bar-close",on:{"click":_vm.closeWindow}},[_c('img',{attrs:{"src":_vm.closeSrc,"alt":"close"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd0e542","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/container-navbar/index.vue
// module id = null
// module chunks = 